import jsonApi, { multipartInstance } from '../../utils/jsonApi'
// import { roles } from '../../utils/constants'

import http from '../../utils/http'

export const createPickupAuthorizationFd = data => {
  return http
    .post('pickup_authorizations', data, {
      'Content-Type': 'multipart/form-data'
    })
    .then(res => res)
}

export const createPickupAuthorizationJson = data => {
  return http
    .post('pickup_authorizations', {
      data: {
        attributes: {
          ...data
        },
        type: 'pickup_authorizations'
      }
    })
    .then(res => res)
}

export const approveTemporaryAuth = data => {
  return http
    .put(`pickup_authorizations/${data}/approve_temporary_authorization`)
    .then(res => res)
}

export const editPickupAuthorizationFd = data => {
  return multipartInstance
    .put(`pickup_authorizations/${data.id}`, data.fd, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(res => res.data)
}

export const purgeAuthorizationPhoto = ({ id }) => {
  return http.delete(`pickup_authorizations/${id}/photo`).then(res => res)
}

export const getPickupAuthorizationById = ({ id, params }) => {
  return jsonApi
    .find('pickup_authorizations', id, {
      params: {
        ...params,
        include: 'authorized_by,pickup_authorization_children.child,school,user'
      }
    })
    .then(res => res)
}

export const getPickupAuthorizations = ({ page, params }) => {
  return jsonApi
    .findAll('pickup_authorization', {
      params: {
        'q[s]': 'created_at desc',
        'page[number]': page || 1,
        include:
          'user,authorized_by,pickup_authorization_children.child.classrooms,school',
        ...params
      }
    })
    .then(res => res)
}

export const deletePickupAuthorization = id => {
  return http.delete(`pickup_authorizations/${id}`).then(res => res)
}
